module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_qualify_banner_variant3_image-f0dc0decfbfe5e84a482e55d40b15d8f.jpg";